import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { apiRequest } from "../../api/apiRequest";

import { useContaContext } from "../../context/ContaContext";

const styles = {
    inputContainer: {
        position: "relative",
        width: "100%",
        maxWidth: "150px",
    },
    input: {
        width: "100%",
        padding: "15px 10px 10px 10px",
        fontSize: "14px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        outline: "none",
    },
    label: {
        position: "absolute",
        top: "10px",
        left: "10px",
        color: "#aaa",
        fontSize: "10px",
        pointerEvents: "none",
        transform: "translateY(-50%)",
        transition: "0.2s ease all",
    },
};

function Switch({ fieldName, notificationStatus = false, onToggle }) {
    const { t } = useTranslation();

    const [isOn, setIsOn] = useState(!!notificationStatus);

    useEffect(() => {
        setIsOn(!!notificationStatus);
    }, [notificationStatus]);

    const handleSubmit = async (newValue) => {
        try {
            await apiRequest("PUT", `/minha-conta-update`, {
                [fieldName]: newValue ? 1 : 0,
            });
            return true;
        } catch (err) {
            alert(t("conta.alertFail"));
            return false;
        }
    };

    const toggleSwitch = async () => {
        const newValue = !isOn;
        const success = await handleSubmit(newValue);

        if (success) {
            setIsOn(newValue);
            onToggle?.(newValue);
        }
    };

    const styles = {
        switchContainer: {
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
        },
        switch: {
            width: "40px",
            height: "16px",
            backgroundColor: isOn ? "#B1B3F8" : "#ccc",
            borderRadius: "25px",
            position: "relative",
            transition: "background-color 0.3s",
        },
        switchToggle: {
            width: "20px",
            height: "20px",
            backgroundColor: isOn ? "#6266F0" : "#6C737F",
            borderRadius: "50%",
            position: "absolute",
            top: "-2px",
            left: isOn ? "20px" : "0px",
            transition: "left 0.3s",
        },
        switchLabel: {
            marginLeft: "10px",
            fontSize: "14px"
        },
    };

    return (
        <div style={styles.switchContainer} onClick={toggleSwitch}>
            <div style={styles.switch}>
                <div style={styles.switchToggle}></div>
            </div>

            <span style={styles.switchLabel}></span>
        </div>
    );
}

function Notificacao() {
    const { t } = useTranslation();
    const [ddi, setDdi] = useState("+55");
    const isBrasil = ddi === '+55';
    const {
        userDataNotificacao, setUserDataNotificacao,
        userDataGeral, setUserDataGeral,
        loading, setLoading,
        error, setError
    } = useContaContext();

    const fetchUserData = async () => {
        try {
            const response = await apiRequest("GET", `/minha-conta`);

            const celularCompleto = response.data.celular?.toString() || "";
            const ddiExtraido = celularCompleto.slice(0, 2);
            let celularExtraido = celularCompleto.slice(2);

            if (ddiExtraido === "55") {
                celularExtraido = celularExtraido.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
            }

            setDdi("+" + (ddiExtraido || "55"));

            setUserDataGeral({
                nome: response.data.nome,
                email: response.data.email,
                whatsapp: response.data.whatsapp,
                celular: celularExtraido,
            });

            setUserDataNotificacao({
                notificacaoEmail: Boolean(response.data.receber_diario_email),
                notificacaoWhatsapp: Boolean(response.data.receber_diario_whatsapp),
                notificacaoSMS: Boolean(response.data.receber_diario_sms)
            });

            setLoading(false);
        } catch (err) {
            setError(err);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserData();
    }, [setError, setLoading, setUserDataNotificacao]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "ddi") {
            const numero = value.replace(/\D/g, "").slice(0, 4);
            setDdi("+" + numero);
        } else {
            setUserDataGeral((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');

        if (value.length > 11) value = value.slice(0, 11);

        if (value.length <= 2) {
            value = `(${value}`;
        } else if (value.length <= 7) {
            value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
        } else {
            value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
        }

        setUserDataGeral((prev) => ({
            ...prev,
            celular: value,
        }));
    };

    const handleSave = async (e) => {
        e.preventDefault();

        try {
            const numeroFinal = (ddi + userDataGeral.celular)
                .replace(/\D/g, "");

            const payload = {
                celular: numeroFinal,
            };

            await apiRequest("PUT", `/minha-conta-update`, payload);

            fetchUserData();

            alert(t("conta.alertSuccess"));
        } catch (err) {
            setError(err);
            alert(t("conta.alertFail"));
        }
    };

    if (loading) {
        return <div> {t("conta.loading")}</div>;
    }

    if (error) {
        return (
            <div>
                {t("conta.error")} {error.message}
            </div>
        );
    }

    return (
        <div style={{ borderRadius: "1rem" }}>
            {/*<div
                className="bg-white shadow-sm d-flex justify-content-between"
                style={{ borderBottom: "1px solid #F3F4F7" }}
            >
                <div
                    className="p-4"
                    style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        width: "50%",
                        color: "#111927",
                    }}
                >
                    {t("conta.email")}
                </div>

                <div
                    className="p-4"
                    style={{ width: "50%", borderBottom: "1px solid #F3F4F7" }}
                >
                    <div className="d-flex justify-content-between align-items-center pb-3">
                        <div>
                            <div
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    color: "#6C737F",
                                }}
                            >
                                {t("conta.emailDescription")}
                            </div>
                        </div>

                        <div>
                            <Switch
                                fieldName="receber_diario_email"
                                notificationStatus={userDataNotificacao.notificacaoEmail}
                                onToggle={(newValue) => handleToggle("notificacaoEmail", newValue)}
                            />
                        </div>
                    </div>
                </div>
            </div>*/}

            {/* <div className="bg-white shadow-sm d-flex justify-content-between">
                <div
                    className="p-4"
                    style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        width: "50%",
                        color: "#111927",
                    }}
                >
                    {t("conta.whatsapp")}
                </div>

                <div
                    className="p-4"
                    style={{ width: "50%", borderBottom: "1px solid #F3F4F7" }}
                >
                    <div className="d-flex justify-content-between align-items-center pb-3">
                        <div>
                            <div
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    color: "#6C737F",
                                }}
                            >
                                {t("conta.whatsappDescription")}
                            </div>
                        </div>

                        <div>
                            <Switch
                                fieldName="receber_diario_whatsapp"
                                notificationStatus={userDataNotificacao.notificacaoWhatsapp}
                            />
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="bg-white shadow-sm p-3 d-flex align-items-center w-100" style={{ borderBottom: "1px solid #F3F4F7" }}>
                <div
                    className="p-2"
                    style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        maxWidth: "200px",
                        color: "#111927",
                    }}
                >
                    {t("conta.phone")}:
                </div>

                <div style={{ maxWidth: "50px", position: "relative", marginRight: "1rem", marginLeft: "0.5rem" }}>
                    <input
                        type="text"
                        id="ddi"
                        name="ddi"
                        style={styles.input}
                        value={ddi}
                        onChange={handleChange}
                    />

                    <label htmlFor="ddi" style={styles.label}>
                        DDI
                    </label>
                </div>

                <div style={styles.inputContainer}>
                    {isBrasil ? (
                        <input
                            type="tel"
                            id="celular"
                            name="celular"
                            style={styles.input}
                            placeholder="(21) 99999-9999"
                            value={userDataGeral?.celular || ""}
                            onChange={handlePhoneChange}
                            onFocus={(e) => {
                                setTimeout(() => {
                                    e.target.setSelectionRange(e.target.value.length, e.target.value.length);
                                }, 0);
                            }}
                        />
                    ) : (
                        <input
                            type="tel"
                            id="celular"
                            name="celular"
                            style={styles.input}
                            value={userDataGeral?.celular || ""}
                            onChange={handleChange}
                        />
                    )}

                    <label htmlFor="celular" style={styles.label}>
                        {t("conta.phoneLabel")}
                    </label>
                </div>

                <button
                    className="btn btn-success"
                    style={{
                        marginLeft: "1rem",
                        fontSize: "12px",
                    }}
                    onClick={handleSave}
                >
                    {t("conta.save")}
                </button>
            </div>

            <div className="bg-white shadow-sm d-flex justify-content-between mt-4">
                <div
                    className="p-4"
                    style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        width: "50%",
                        color: "#111927",
                    }}
                >
                    {t("conta.sms")}
                </div>

                <div
                    className="p-4"
                    style={{ width: "50%", borderBottom: "1px solid #F3F4F7" }}
                >
                    <div className="d-flex justify-content-between align-items-center pb-3">
                        <div>
                            <div
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    color: "#6C737F",
                                }}
                            >
                                {t("conta.smsDescription")}
                            </div>
                        </div>

                        <div>
                            <Switch
                                fieldName="receber_diario_sms"
                                notificationStatus={userDataNotificacao.notificacaoSMS}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Notificacao;
